var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { nanoid } from "nanoid";
import "./navigation.scss";
import DropDown from "../../../components/DropDown/index";
import pubsub from "@viewlift/pubsub";
import { arrowRight, arrowUp, arrowDown } from "../../../../images/icon";
import StandardDropDownMenu from "../StandardDropdownMenu";
var Navigation = function (_a) {
    var _b, _c, _d;
    var navigation = _a.navigation, _e = _a.navigationItems, initialItems = _e === void 0 ? [] : _e, isMobile = _a.isMobile, checkToShow = _a.checkToShow, brand = _a.brand;
    var primaryNavigation = navigation.primary || [];
    var _f = __read(useState(initialItems), 2), navigationItems = _f[0], setNavigationItems = _f[1];
    var _g = __read(useState(null), 2), showDropDown = _g[0], setShowDropDown = _g[1];
    var handleDropDownIndex = function (index) {
        setShowDropDown(function (prev) { return (prev === index ? null : index); });
    };
    var handleKeyDown = function (e, nav, index) {
        var _a, _b, _c;
        // “activate” on Enter or Space
        var thumbnailType = ((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.app_data) === null || _a === void 0 ? void 0 : _a.appcmsMain) === null || _b === void 0 ? void 0 : _b.navigationConfig) === null || _c === void 0 ? void 0 : _c.dropdownNavigationType) ||
            "STANDARD";
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (thumbnailType === "THUMBNAIL" && !isMobile) {
                pubsub.publish("ActiveThumbnailTab", nav);
            }
            setShowDropDown(function (prev) { return (prev === index ? null : index); });
        }
    };
    useEffect(function () {
        // If your real checkToShow needs a second arg (e.g. store),
        // pass it here. Otherwise store will be undefined.
        checkToShow(primaryNavigation, brand).then(function (navList) {
            setNavigationItems(navList);
        });
    }, [primaryNavigation, checkToShow, brand]);
    var thumbnailType = ((_d = (_c = (_b = window === null || window === void 0 ? void 0 : window.app_data) === null || _b === void 0 ? void 0 : _b.appcmsMain) === null || _c === void 0 ? void 0 : _c.navigationConfig) === null || _d === void 0 ? void 0 : _d.dropdownNavigationType) ||
        "STANDARD";
    return (React.createElement("nav", { className: "navigation-container", role: "navigation" },
        React.createElement("ul", null, navigationItems.map(function (nav, index) {
            // external link
            if (nav === null || nav === void 0 ? void 0 : nav.newTab) {
                return (React.createElement("li", { tabIndex: 0, className: "navigation-link-container", key: nanoid() },
                    React.createElement("a", { className: "navigation-link", href: nav.url, target: "_blank", rel: "noopener noreferrer" },
                        React.createElement(DropDown, { url: nav.url, title: nav.title, open: showDropDown, isMobile: isMobile, icon: nav.icon || "", hasItem: nav.items.length > 0 }),
                        isMobile && (React.createElement("div", { tabIndex: 0, className: "navigation-link-icon desktopDropDownArrow" }, arrowRight())))));
            }
            // dropdown parent
            if (nav.items.length > 0) {
                return (React.createElement("li", { tabIndex: 0, className: "navigation-link-container", key: nanoid() },
                    React.createElement("div", { className: thumbnailType === "THUMBNAIL"
                            ? "navigation-link thumbnail-link-menu"
                            : "navigation-link", onKeyDown: function (e) { return handleKeyDown(e, nav, index); }, onClick: function () { return handleDropDownIndex(index); }, onMouseOver: function () {
                            if (thumbnailType === "THUMBNAIL" && !isMobile) {
                                pubsub.publish("ActiveThumbnailTab", nav);
                            }
                        }, "aria-expanded": showDropDown === index },
                        React.createElement(DropDown, { url: nav.url, title: nav.title, open: showDropDown, isMobile: isMobile, hasItem: nav.items.length > 0, index: index, thumbnailType: thumbnailType }, (thumbnailType === "STANDARD" || isMobile) && (React.createElement(StandardDropDownMenu, { navigation: navigation, navigationItems: navigationItems, isMobile: isMobile, checkToShow: checkToShow, thumbnailType: thumbnailType, nav: nav, brand: brand }))),
                        !isMobile && showDropDown !== index ? (React.createElement("div", { className: "navigation-link-icon desktopDropDownArrow" }, arrowDown())) : showDropDown === index ? (React.createElement("div", { className: "navigation-link-icon" }, arrowUp())) : (isMobile && (React.createElement("div", { className: "navigation-link-icon" }, arrowRight()))))));
            }
            // simple internal link
            return (React.createElement("li", { className: "navigation-link-container", key: nanoid() },
                React.createElement(Link, { className: "navigation-link", to: { pathname: nav.url }, "aria-expanded": "false" },
                    React.createElement(DropDown, { url: nav.url, title: nav.title, icon: nav.icon || "", isMobile: isMobile, hasItem: nav.items.length > 0 }),
                    isMobile && (React.createElement("div", { className: "navigation-link-icon" }, arrowRight())))));
        }))));
};
export default React.memo(Navigation);
